import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { applyDefaultApiAuthorization } from "@/apiAuth";

// Global fetch interceptor - adds auth token to /api/ requests
const originalFetch = window.fetch;
window.fetch = function(url, options = {}) {
  const token = localStorage.getItem('session_token');
  return originalFetch(url, applyDefaultApiAuthorization(url, options, token));
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<React.StrictMode><App /></React.StrictMode>);
